import { Image } from '../models/Item'

export const imageArrayToStringArray = (imageArray: Image[]): string[] => {
  let newArray: string[] = []

  imageArray.forEach(image => {
    newArray.push(image.url)
  })
  return newArray
}

export const stringArrayToImageArray = (
  imageArray: string[]
): { position: number; url: string }[] => {
  const newArr = [] as { position: number; url: string }[]
  imageArray.forEach(image => {
    newArr.push({
      position: imageArray.indexOf(image),
      url: image
    })
  })
  return newArr
}
